export default function keepCalendarViewState(viewType) {
   return {
      type : "KEEP_CALENDAR_VIEW",
      payload : viewType,
   }
}



// WEBPACK FOOTER //
// ./src/actions/events/keepCalendarViewStateAction.js